import Application from '../../../index.js';

Application.getRouter().beforeHooks.push(function setDocumentTitle(to, from, next) {
    const title = to.meta.title;
    document.title = String(Application.getI18n().t(title));
    next();
});

